import { get, post } from './http'
const campaignPath = '/operating-platform/campaign/frontend'
const CONTEST = {
  // 抽奖填写收货地址
  deliveryLottery: (params) => {
    return post(`${campaignPath}/lottery/fill-in/delivery`, params)
  },
  // 抽奖查询评论抽奖活动基础信息
  getLotteryBase:(params) => {
    return get(`${campaignPath}/lottery/info`, params)
  },
  // 抽奖查询用户中奖信息
  getLotteryUserInfo:(params) => {
    return get(`${campaignPath}/lottery/user/winingInfo`, params)
  },
  // 根据帖子查询活动信息
  getLotteryThreadStatus:(params) => {
    return get(`${campaignPath}/get-status`, params)
  },
  // 填写周年庆抽奖地址
  editReceiveAddress: (params) => {
    return post(`${campaignPath}/lottery-activity/delivery/fill-in`, params)
  }
}
// 报名活动
const SIGNUP_ACTIVITY = {
  // 获取活动信息及表单配置页面设置
  queryActivityFormInfo: (params) => {
    params.needToastErr = true
    return get(`${campaignPath}/signup-activity/info`, params)
  },
  // 获取表单题目配置及提交答案
  queryFormQuestionInfo: (params) => {
    params.needToastErr = true
    return get(`${campaignPath}/signup-activity/subjects-answer`, params)
  },
  // 提交答案
  submitQuestionAnswer: (params, type = 'add') => {
    params.needToastErr = true
    return post(`${campaignPath}/signup-activity/user-record/${type}`, params)
  },
  // 国家选择器列表
  queryCountrySeletorList: () => {
    return get(`${campaignPath}/signup-activity/country/list`)
  },
  // 统计查看量
  onRecordView: (params) => {
    return post(`${campaignPath}/signup-activity/view/stat`, params)
  },
  
}
export default { ...CONTEST, ...SIGNUP_ACTIVITY }